import { render, staticRenderFns } from "./SidebarComp.vue?vue&type=template&id=6a846f44&scoped=true&"
var script = {}
import style0 from "./SidebarComp.vue?vue&type=style&index=0&id=6a846f44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a846f44",
  null
  
)

export default component.exports